// Libs
import { useContext } from 'react';

// Components
import Timeline from '../../components/timeline/timeline';
import Back from '../../components/back/back';

// Contexts
import { StateContext } from '../../contexts/state';

// Assets
import { ReactComponent as Loading } from '../../asset/loading.svg';

// Container
import Error from '../../containers/error/error';

// Templates
import View from '../../templates/view';

import './track.scss';

const TrackView = ({ match }) => {
	const state = useContext(StateContext);
	const code = match.params.id?.toLowerCase();

	return (
		<View
			className="track-view"
			showBackgroundLogo={state.current?.code?.toLowerCase() === code && !state.fetching}
		>
			{state.current && state.current.code?.toLowerCase() === code && (
				<>
					<div className="track-view__locations">
						<div className="track-view__locations__origin-wrapper">
							<Back />
							<div className="track-view__locations__origin">
								<span className="track-view__locations__title">Origin</span>
								<p className="track-view__locations__address">{state.current?.origin}</p>
							</div>
						</div>
						<div className="track-view__locations__destination">
							<span className="track-view__locations__title">Destination</span>
							<p className="track-view__locations__address">{state.current?.destination}</p>
						</div>
					</div>
					<Timeline items={state.current?.details} />
				</>
			)}
			{state.fetching ? (
				<div className="track-view__loading">
					<Loading />
				</div>
			) : (
				state.current?.code?.toLowerCase() !== code && <Error code={code} />
			)}
		</View>
	);
};

export default TrackView;
